// extracted by css-extract-rspack-plugin
export default {"cls1":"StandaloneSearchContainer-cls1_But","cls2":"StandaloneSearchContainer-cls2_FMp StandaloneSearchContainer-cls1_But"};